import React from 'react';
import styled from 'styled-components';

const GoBackButton = (props) => {
    return (
        <Button>
            <button type="button" onClick={props.clickHandler}><img src={require('./style/img/top_back_arrow.svg')} alt={"뒤로가기"}/></button>
        </Button>
    );
};

const Button = styled.div`
    position:fixed;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    background-color: #fff;
    align-items: center;
    top:0;
    left:0;
    box-sizing: border-box;
    padding-left: 20px;
    z-index:10;
    height: 50px;

    button {
        color: ${props => props.color};
        font-size: 30px;
        width: 50px;
        height: 100%;
        
        img {
          display: flex;
          width: 60%;
        }
    }

    @media screen and (min-width:600px) {
        width: 375px;
        left:50%;
        transform: translateX(-50%);
    }
`;

export default GoBackButton;
